import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'

interface Project {
  id: string
  name: string
  description?: string
  organizationId: string
  createdAt: string
  updatedAt: string
}

export const useProjects = () => {
  return useQuery<Project[]>({
    queryKey: ['projects'],
    queryFn: async () => {
      const response = await api.get('/projects')
      return response.data
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}

export const useProject = (projectId: string) => {
  return useQuery<Project>({
    queryKey: ['projects', projectId],
    queryFn: async () => {
      const response = await api.get(`/projects/${projectId}`)
      return response.data
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })
}